import Model from '@models/Model'

class Office extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'name',
        'created_at',
        'updated_at',
        'discarded_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
        'discarded_at',
      ],
      relationships: {},
    })
  }
}

export default Office
